import React, { useEffect, useMemo } from "react";
import ActionCard from "components/ActionCard";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { NEW_DICTIONARY } from "constants/routes";
import { Link, useNavigate } from "react-router-dom";
import {
  backupAllDictionaries,
  createDictonary,
  restoreDictionaries,
} from "slices/dictionary/actions/dictionary";
import { useDispatch } from "react-redux";
import { permissionsTooltipMessage } from "constants/dictionary";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { showInlineAlert } from "slices/app/appSlice";
import { alertVariants } from "@visiblethread/react-components/dist/components/Alert";

const DictionaryActions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  /* eslint-disable no-undef */
  const hasPermissions = useMemo(() => {
    const { licensed, roles } = UserInfo;
    return !(!licensed || !roles.split(",").includes("dictionary"));
  }, [UserInfo.licensed, UserInfo.roles]);
  /* eslint-enable no-undef */

  useEffect(() => {
    if (!hasPermissions) {
      dispatch(
        showInlineAlert({
          variant: alertVariants.warning,
          text: "You do not have permission to edit dictionaries",
        })
      );
    }
  }, [hasPermissions]);

  const handleCreateDictionary = () => {
    dispatch(createDictonary());
  };

  const createDictionaryButton = () =>
    hasPermissions ? (
      <Link
        to={NEW_DICTIONARY}
        className="primary_link"
        onClick={handleCreateDictionary}
      >
        Create
      </Link>
    ) : (
      <Button
        variant={buttonVariants.primary}
        content="Create"
        onClick={() => {}}
        disabled
        title={permissionsTooltipMessage}
      />
    );

  const uploadDictionaryButton = () => (
    <Button
      onClick={() =>
        dispatch(showModal(modalTypes.IMPORT_DICTIONARY, { navigate }))
      }
      variant={buttonVariants.secondary}
      content={<>Import</>}
      disabled={!hasPermissions}
      title={!hasPermissions ? permissionsTooltipMessage : ""}
    />
  );

  const backupDictionariesButton = () => (
    <Button
      onClick={() => dispatch(backupAllDictionaries())}
      variant={buttonVariants.secondary}
      content={<>Backup</>}
      disabled={!hasPermissions}
      title={!hasPermissions ? permissionsTooltipMessage : ""}
    />
  );

  const restoreDictionariesButton = () => {
    const onOk = (formData) => dispatch(restoreDictionaries(formData));
    return (
      <Button
        onClick={() =>
          dispatch(
            showModal(modalTypes.IMPORT_FILE, {
              title: "Restore Dictionaries From Zip",
              accepts: ".zip",
              onOk,
              okText: "Restore",
            })
          )
        }
        variant={buttonVariants.secondary}
        content={<>Restore</>}
        disabled={!hasPermissions}
        title={!hasPermissions ? permissionsTooltipMessage : ""}
      />
    );
  };

  return (
    <div className="dictionary__actions">
      <ActionCard
        header="Create Dictionary"
        description="Start creating a dictionary from scratch"
        cta={createDictionaryButton()}
      />
      <ActionCard
        header="Import Dictionary"
        description="Import a Dictionary from a CSV file or Archive"
        cta={uploadDictionaryButton()}
      />
      <ActionCard
        header="Backup Dictionaries"
        description="Export all dictionaries to a ZIP file"
        cta={backupDictionariesButton()}
      />
      <ActionCard
        header="Restore Dictionaries"
        description="Import dictionaries from a ZIP file"
        cta={restoreDictionariesButton()}
      />
    </div>
  );
};

export default DictionaryActions;
